module.exports = __webpack_public_path__ + "media/images/CustomerOnlyIcon-01-357fdd85.png";